import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ahaui/ahaui/apps/docs/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
export const query = graphql`
  query MediaMDXQuery {
    metadata: componentMetadata(displayName: { eq: "Media" }) {
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "media"
    }}>{`Media`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Allow browsers to determine video or slideshow dimensions based on the width of their containing block by creating an intrinsic ratio that will properly scale on any device.`}</p>
    <p>{`You don't need to include `}<inlineCode parentName="p">{`frameborder="0"`}</inlineCode>{`  in your iframes. The aspect ratio is controlled via the `}<inlineCode parentName="p">{`aspectRatio`}</inlineCode>{` prop.`}</p>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "element-type"
    }}>{`Element Type`}</h3>
    <div className="Grid">
  <div className="u-sizeFull lg:u-size1of2 u-marginBottomMedium">
    <p>
      HTML5 Video Player by using&nbsp;
      <code>&lt;embed&gt;</code>
      &nbsp;tag:
    </p>
    <CodeView codeText={'<Media src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/webm" title="Video example" />'} mdxType="CodeView" />
  </div>
  <div className="u-sizeFull lg:u-size1of2 u-marginBottomMedium">
    <p>
      Showing an image by using&nbsp;
      <code>&lt;img&gt;</code>
      &nbsp;tag:
    </p>
    <CodeView codeText={'<Media as="img" src="https://images.pexels.com/photos/461198/pexels-photo-461198.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260" alt="Image" title="Image from https://images.pexels.com" />'} mdxType="CodeView" />
  </div>
    </div>
    <h3 {...{
      "id": "aspect-ratio"
    }}>{`Aspect Ratio`}</h3>
    <p>{`Embed Google Maps and videos from Youtube, Vimeo by using `}<inlineCode parentName="p">{`<iframe>`}</inlineCode>{` tag:`}</p>
    <div className="Grid">
  <div className="u-sizeFull lg:u-size1of2 u-marginBottomMedium">
    <p><em>Square (1:1)</em></p>
    <CodeView codeText={'<Media as="iframe" aspectRatio="square" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50585.80752281471!2d-122.40243146636166!3d37.58773037709596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7625549b8e59%3A0xbbcfa3e532f8f4f!2sBurlingame%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1587037928284!5m2!1sen!2s" />'} mdxType="CodeView" />
  </div>
  <div className="u-sizeFull lg:u-size1of2 u-marginBottomMedium">
    <p><em>Classic (4:3)</em></p>
    <CodeView codeText={'  <Media as="iframe" aspectRatio="classic" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50585.80752281471!2d-122.40243146636166!3d37.58773037709596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7625549b8e59%3A0xbbcfa3e532f8f4f!2sBurlingame%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1587037928284!5m2!1sen!2s" />'} mdxType="CodeView" />
  </div>
  <div className="u-sizeFull lg:u-size1of2 u-marginBottomMedium">
    <p><em>Wide (16:9)</em></p>
    <CodeView codeText={'<Media as="iframe" aspectRatio="wide" src="https://player.vimeo.com/video/311342841?title=0&byline=0&portrait=0" />'} mdxType="CodeView" />
  </div>
  <div className="u-sizeFull lg:u-size1of2 u-marginBottomMedium">
    <p><em>Cinema (21:9)</em></p>
    <CodeView codeText={' <Media as="iframe" aspectRatio="cinema" src="https://www.youtube.com/embed/ISJMsVhY5Yk" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />'} mdxType="CodeView" />
  </div>
    </div>
    <h2 {...{
      "id": "design-reference"
    }}>{`Design Reference`}</h2>
    <p>{`N/A`}</p>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.metadata} mdxType="ComponentApi" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      